import { useMemo } from 'react';

import { hasValue } from 'utils/hasValue';

import { useDraftDefinition } from '../contexts/DraftDefinitionProvider';
import {
  type FieldDefinition,
  type RawStepField,
  enhanceFieldDefinition
} from '../utils/fieldDefinitionEnhancer';
import type { DraftSteps } from '../utils/types';

export type StepFieldDefinitions = Array<FieldDefinition>;

export const useDraftStepFields = (step: DraftSteps) => {
  const { fieldDefinitions } = useDraftDefinition();

  const fields: StepFieldDefinitions = useMemo(() => {
    const stepFields = fieldDefinitions[step];
    if (hasValue(stepFields) === false) {
      return [];
    }

    return Object.keys(stepFields)
      .map(
        (field) =>
          ({
            definition: stepFields[field],
            name: field,
            fullName: `${step}.${field}`,
            step
          }) as RawStepField
      )
      .map(enhanceFieldDefinition);
  }, [fieldDefinitions, step]);

  return { fields };
};
